(function(){
  'use strict';

  if (window.__userMenuInitialized) return;
  window.__userMenuInitialized = true;

  function qs(root, sel){ return (root||document).querySelector(sel); }
  function on(el, ev, cb, opts){ el && el.addEventListener(ev, cb, opts||false); }

  async function doLogout(){
    try {
      const r = await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } });
      if (!r.ok) return false;
      return true;
    } catch(e){ return false; }
  }

  function togglePanel(root, show){
    const panel = qs(root, '[data-menu-panel]');
    if (!panel) return;
    const isShown = !panel.classList.contains('d-none');
    const next = (typeof show === 'boolean') ? show : !isShown;
    panel.classList.toggle('d-none', !next);
  }

  function initUserMenu(){
    const root = document.getElementById('user-menu');
    if (!root) return;

    const btn = qs(root, '[data-menu-toggle]');
    const nameEl = qs(root, '[data-user-name]');
    const logoutLink = qs(root, '[data-logout]');
    const settingsLink = qs(root, '[data-settings]');
    const themeToggle = qs(root, '[data-theme-toggle]');
    const themeCheckbox = qs(root, '[data-theme-checkbox]');
    
    // Use server-provided auth status (no API request needed)
    const authStatus = window.SERVER_AUTH_STATUS || { isAuthenticated: false, userEmail: null };
    
    // Helper function to get translations
    function translate(key) {
      if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
        const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
        const translation = window.TranslationRegistry.translate(key, lang);
        if (translation !== key) return translation;
      }
      if (window.LanguageManager && typeof window.LanguageManager.translate === 'function') {
        const translation = window.LanguageManager.translate(key);
        if (translation !== key) return translation;
      }
      return key === 'user_menu_guest' ? 'Guest' : key;
    }
    
    // Update UI based on server-provided status
    if (authStatus.isAuthenticated && authStatus.userEmail){
      nameEl && (nameEl.textContent = authStatus.userEmail);
      // Remove translation attribute when showing email
      if (nameEl) {
        nameEl.removeAttribute('data-translate');
      }
      logoutLink && logoutLink.classList.remove('d-none');
    } else {
      const guestText = translate('user_menu_guest');
      nameEl && (nameEl.textContent = guestText);
      // Ensure translation attribute is set for Guest
      if (nameEl) {
        nameEl.setAttribute('data-translate', 'user_menu_guest');
        // Re-apply translations if TranslationApplier is available
        if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
          window.TranslationApplier.apply();
        }
      }
      logoutLink && logoutLink.classList.add('d-none');
    }
    
    // Mark as ready
    if(window.ComponentLoadingStatus){
      try {
        let caption = 'User menu loaded';
        if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
          const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
          caption = window.TranslationRegistry.translate('loader_stage_user_menu_loaded', lang);
        }
        window.ComponentLoadingStatus.update('userMenu', 'ready', caption);
      } catch(_){}
    }

    on(btn, 'click', function(ev){
      ev.preventDefault();
      // No need to refresh status - use server-provided data
      togglePanel(root);
      try { btn.setAttribute('aria-expanded', String(!qs(root,'[data-menu-panel]').classList.contains('d-none'))); } catch(_) {}
    });

    on(document, 'click', function(ev){
      if (!root.contains(ev.target)) { togglePanel(root, false); try { btn.setAttribute('aria-expanded', 'false'); } catch(_) {} }
    });

    on(logoutLink, 'click', async function(ev){
      ev.preventDefault();
      const ok = await doLogout();
      if (ok){
        // Check if we're on search page - if so, redirect to same page with guest mode
        const currentPath = window.location.pathname;
        const isSearchPage = /^\/[a-z]{2}\/$/i.test(currentPath) || currentPath === '/' || currentPath.match(/^\/[a-z]{2}\//i);
        
        if (isSearchPage) {
          // Redirect to same page with skip=1 to enable guest mode
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('skip', '1');
          window.location.href = currentUrl.toString();
        } else {
          // For other pages, just reload
          const guestText = translate('user_menu_guest');
          nameEl && (nameEl.textContent = guestText);
          if (nameEl) {
            nameEl.setAttribute('data-translate', 'user_menu_guest');
          }
          togglePanel(root, false);
          try { location.reload(); } catch(_) {}
        }
      }
    });

    on(settingsLink, 'click', function(){ togglePanel(root, false); try { btn.setAttribute('aria-expanded','false'); } catch(_) {} });

    // Theme toggle handler - инициализация состояния checkbox
    if (themeCheckbox) {
      // Устанавливаем начальное состояние checkbox на основе текущей темы
      const htmlEl = document.documentElement;
      const isCurrentlyDark = htmlEl.getAttribute('data-theme') === 'dark';
      themeCheckbox.checked = isCurrentlyDark;
      
      // Обработчик изменения toggle switch
      on(themeCheckbox, 'change', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        const htmlEl = document.documentElement;
        const isDark = themeCheckbox.checked;
        
        // Toggle theme
        if (isDark) {
          htmlEl.setAttribute('data-theme', 'dark');
          try {
            if (window.localStorage) window.localStorage.setItem('theme', 'dark');
          } catch(_) {}
        } else {
          htmlEl.removeAttribute('data-theme');
          try {
            if (window.localStorage) window.localStorage.setItem('theme', 'light');
          } catch(_) {}
        }
        
        // Синхронизация с настройками лекций (если мы на странице лекций)
        try {
          if (typeof window.setPageProperty === 'function') {
            window.setPageProperty('cNightMode', isDark);
          }
        } catch(_) {}
        
        // Try to call app's toggleTheme if available (for module notifications)
        try {
          if (window.appInitializationManager && typeof window.appInitializationManager.toggleTheme === 'function') {
            window.appInitializationManager.toggleTheme();
          }
        } catch(_) {}
        
        // Не закрываем меню после переключения - пользователь может переключать несколько раз
      });
      
      // Слушаем изменения темы извне (например, через системные настройки)
      if (window.matchMedia) {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        function updateCheckboxFromTheme() {
          const htmlEl = document.documentElement;
          const isDark = htmlEl.getAttribute('data-theme') === 'dark';
          if (themeCheckbox.checked !== isDark) {
            themeCheckbox.checked = isDark;
          }
        }
        
        // Обновляем при изменении data-theme через MutationObserver
        if (window.MutationObserver) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
                updateCheckboxFromTheme();
              }
            });
          });
          observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
        }
      }
    }
  }

  // Menu items are dynamically generated on backend via MenuItemsService
  // No need to check permissions in JavaScript - backend already filters menu items by role
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      initUserMenu();
    });
  } else {
    initUserMenu();
  }
})();


